import {
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarFilterButton
} from '@mui/x-data-grid-pro';
import moment from 'moment';
import React from 'react';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { usePermissionWrapper } from '../common/hooks/usePermissionWrapper';

export const getExportDocumentName = (userPreferedDateFormat: string) => {
  const exportDateFormat = userPreferedDateFormat.includes('/')
    ? userPreferedDateFormat.replaceAll('/', '_')
    : userPreferedDateFormat.replaceAll('-', '_');
  return 'ISF Binder ' + moment(new Date()).format(`${exportDateFormat.toUpperCase()} hh_mm A`);
};

export const CustomToolbar: React.FC = () => {
  const { userPreferedDateFormat } = usePreferedDateFormat();
  const documentName = getExportDocumentName(userPreferedDateFormat);
  const { checkPermission } = usePermissionWrapper();
  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton onResize={undefined} onResizeCapture={undefined} />
      <GridToolbarFilterButton onResize={undefined} onResizeCapture={undefined} />
      <GridToolbarDensitySelector onResize={undefined} onResizeCapture={undefined} />
      {checkPermission('export_isf_results') && (
        <GridToolbarExport
          csvOptions={{
            fileName: documentName
          }}
        />
      )}
    </GridToolbarContainer>
  );
};
